import { render } from "./ConceptsTable.vue?vue&type=template&id=57c88092&scoped=true"
import script from "./ConceptsTable.vue?vue&type=script&lang=js"
export * from "./ConceptsTable.vue?vue&type=script&lang=js"

import "./ConceptsTable.vue?vue&type=style&index=0&id=57c88092&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c88092"]])

export default __exports__